import {compose} from 'redux';
import {connect} from 'react-redux';
import {getLocale} from '../../selectors/system';
import IntlMessageFormat from 'intl-messageformat';
import React from 'react';
import StarRating from '@homeaway/react-star-rating';
import {withTranslationsAsProps} from '../../components/translations';
import './listing-reviews.less';

export function ListingReviews({
    averageRating,
    langReviews,
    locale,
    reviewCount = 0
}) {
    // do not show if no reviews
    if (!reviewCount || !averageRating) {
        return null;
    }
    const labelReviews = new IntlMessageFormat(langReviews, locale).format({COUNT: reviewCount});
    return (
        <span className="listing-reviews flex">
            <StarRating rating={averageRating}/>
            <span className="listing-reviews__label">{labelReviews}</span>
        </span>
    );
}

const mapStateToProps = (state) => ({locale: getLocale(state)});

export default compose(
    withTranslationsAsProps({
        'tripboards.reviews.count': 'langReviews'
    }),
    connect(mapStateToProps)
)(ListingReviews);


// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-reviews.js